import ReactMapboxGl from 'react-mapbox-gl'
const MAPBOX_TOKEN =
  'pk.eyJ1IjoiYjA4d2FsbHMiLCJhIjoiY2p3NzU4em9kMWUzaTQ4cXNxN24zbHJlaCJ9.FGyWZwzZKd93aHlsAE4FMw'

const Map = ReactMapboxGl({
  accessToken: MAPBOX_TOKEN,
})

export default Map
